import { OptionModel } from './optionModel';

export class DialogItemModel extends OptionModel {
  parentId: string;
  isReadOnly: boolean;
  totalChemical: number;
  constructor(
    text: string,
    id: any,
    parentId: any,
    isReadOnly?: boolean,
    checked: boolean = false,
    totalChemical: number = 0,
  ) {
    super(text, id, checked);
    this.parentId = parentId;
    this.isReadOnly = isReadOnly as boolean;
    this.totalChemical = totalChemical;
  }
}
